"use strict";
/**
 * Created by aghavni.grigoryan on 7/19/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ListReportFieldType;
(function (ListReportFieldType) {
    ListReportFieldType[ListReportFieldType["ROW_CATEGORY_FIELD"] = 0] = "ROW_CATEGORY_FIELD";
    ListReportFieldType[ListReportFieldType["COLUMN_CATEGORY_FIELD"] = 1] = "COLUMN_CATEGORY_FIELD";
    ListReportFieldType[ListReportFieldType["COLUMN_MEASURE_FILED"] = 2] = "COLUMN_MEASURE_FILED";
})(ListReportFieldType = exports.ListReportFieldType || (exports.ListReportFieldType = {}));
//# sourceMappingURL=list-report-field.js.map